exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox-group[data-v-79a95da7] {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}", ""]);

// exports
